import { expand } from 'uri-template-lite';

import { ValidationDashboardUpdateSchema } from '../schema/ValidationDashboardUpdateSchema';
import { ValidationDashboardUpdateValidFormType } from '../types';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';

const updateValidationDashboard = (
  id: number,
  validationDashboard: Partial<ValidationDashboardUpdateValidFormType>,
) =>
  apiClient
    .put<ValidationDashboardUpdateValidFormType>(
      expand(ValidationDashboardUrl.ENTITY, { id }),
      ValidationDashboardUpdateSchema.parse(validationDashboard),
    )
    .then((response) => response.data);

const deleteValidationDashboard = (id: number) =>
  apiClient
    .delete<void>(expand(ValidationDashboardUrl.ENTITY, { id }))
    .then((response) => response.data);

export const useMutateValidationDashboardQuery = createApiMutationHook(
  ['validationDashboard'],
  getMutationFn(
    undefined,
    updateValidationDashboard,
    deleteValidationDashboard,
  ),
);
